import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import CustomerPrimaryAddressBookAddOrUpdate from "./CustomerAddOrUpdate";
import { showNotification, successNofication } from "src/shared/components/Notification";
import PndRestApi from "src/utils/pnd/PndRestApi";
import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";
import CloseIcon from '@mui/icons-material/Close';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import { CircularProgress } from '@mui/material';

const CustomerDetailsModal = ({ modalShow, setModalShow, isTitle, dataInfo }) => {

    const [isMapData, setMapData] = useState(null);
    const [isRedirect, setIsRedirect] = useState(false);
    const [mapInfo, setMapInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    const toggle = () => {
        if (!loading) {
            setModalShow(prevState => !prevState);
        }
    };

    if (isRedirect) {
        window.location.reload();
        return <Redirect to="/web_app/pnd_merchant/customer/view" />;
    }

    const handleSubmit = async (formValues) => {
        try {
            setLoading(true);
            formValues["merchantId"] = localStorage.getItem("mi");
            if (formValues["addressBookName"] && typeof formValues["addressBookName"] === 'object') {
                formValues["addressBookName"] = formValues["addressBookName"]["label"];
            }

            if (isMapData != null) { //New Record
                formValues["address"] = isMapData;
            }

            if (isMapData === null && dataInfo?.address) { //update
                formValues["address"] = dataInfo?.address;
            }

            if (formValues["address"] == null || formValues["address"] === 'undefined') {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    `Message: Please fill in the address first.`,
                );
                setLoading(false);
                return;
            }

            if (mapInfo) {
                const landmark = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 4);
                const street = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 3);
                const area = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 2);
                const zone = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 7);
                const city = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 8);
                const emirates = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 1);
                const longitude = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 9);
                const latitude = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 10);
                const grl = mapInfo.AddressElements.find(element => element.AddressElementTypeCode === 5);

                if (landmark) formValues["landMark"] = landmark.Value;
                if (street) formValues["streetName"] = street.Value;
                if (area) formValues["area"] = area.Value;
                if (zone) formValues["zoneName"] = zone.Value;
                if (city) formValues["city"] = city.Value;
                if (emirates) formValues["emirates"] = emirates.Value;
                if (latitude) formValues["latitude"] = latitude.Value;
                if (longitude) formValues["longitude"] = longitude.Value;
                if (grl) formValues["grl"] = grl.Value;
            }

            if (formValues["status"]) {
                formValues["status"] = 1;
            } else {
                formValues["status"] = 0;
            }

            const response = await PndRestApi.AddOrUpdateMerchantCustomer(formValues);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName="ltr-support"
                className="theme-light ltr-support"
                size="lg"
                backdrop={loading ? "static" : true}
                style={{ maxWidth: '900px' }}
            >
                {/* Modern Modal Header */}
                <div
                    className="position-relative"
                    style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        padding: '1.5rem 2rem',
                        borderRadius: '0.5rem 0.5rem 0 0',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '12px',
                                    backdropFilter: 'blur(10px)'
                                }}
                            >
                                <PersonPinIcon style={{ fontSize: '28px', color: '#fff' }} />
                            </div>
                            <div>
                                <h4
                                    className="m-0 text-white fw-bold"
                                    style={{
                                        fontSize: '1.5rem',
                                        letterSpacing: '0.5px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {isTitle}
                                </h4>
                                <p className="m-0 text-white-50 small">
                                    {dataInfo ? 'Update merchant customer details' : 'Add new merchant customer details'}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={toggle}
                            disabled={loading}
                            className="btn-close-custom"
                            style={{
                                background: 'rgba(255,255,255,0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                opacity: loading ? 0.5 : 1
                            }}
                            onMouseEnter={(e) => {
                                if (!loading) {
                                    e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                                    e.currentTarget.style.transform = 'rotate(90deg)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'rotate(0deg)';
                            }}
                        >
                            <CloseIcon style={{ color: '#fff', fontSize: '20px' }} />
                        </button>
                    </div>
                </div>

                {/* Modal Body */}
                <ModalBody className="p-0" style={{ background: '#f8f9fa' }}>
                    {loading && (
                        <div
                            className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{
                                background: 'rgba(255,255,255,0.9)',
                                zIndex: 1050,
                                backdropFilter: 'blur(4px)'
                            }}
                        >
                            <div className="text-center">
                                <CircularProgress size={50} style={{ color: '#667eea' }} />
                                <p className="mt-3 text-muted fw-bold">Processing...</p>
                            </div>
                        </div>
                    )}

                    <div style={{ maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
                        <CustomerPrimaryAddressBookAddOrUpdate
                            onSubmit={handleSubmit} dataInfo={dataInfo} setMapData={setMapData}
                            status={dataInfo?.status} address={dataInfo?.address} setMapInfo={setMapInfo} addressType={dataInfo?.addressType}
                        />
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default connect((state) => ({
    rtl: state.rtl,
}))(CustomerDetailsModal);
